module.exports = __webpack_public_path__ + "static/img/bg24.0898852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg24.jpg
// module id = lO3V
// module chunks = 1